<template>
  <div v-for="item in processedData"
       :key="item.channel.originId"
       class="bx-epg-search__row">
    <Channel :channel="item.channel" />
    <div>
      <Broadcast v-for="broadcast in sliceBroadcasts(item.broadcasts)"
                 :key="broadcast.originId"
                 :broadcast="broadcast" />
    </div>
  </div>
</template>

<script>
import Channel from './Channel.vue'
import Broadcast from './Broadcast.vue'

export default {
  components: {
    Channel,
    Broadcast
  },
  props: {
    epgData: {
      type: Array,
      default: () => []
    },
    viewMode: {
      type: String,
      default: 'overview' // or "channel"
    }
  },
  computed: {
    processedData () {
      if (!Array.isArray(this.epgData) || this.epgData.length === 0) return []
      // mode "channel" is a special mode where we only have one channel
      // but want to display the channel name for each broadcast
      return this.viewMode === 'channel'
        ? this.epgData[0]?.broadcasts.map((broadcast) => ({
          channel: this.epgData[0].channel, // same channel for all
          broadcasts: [broadcast] // separate broadcast as array
        }))
        : this.epgData // Standard data structure
    }
  },
  methods: {
    sliceBroadcasts (broadcasts) {
      // only show 2 broadcasts in overview mode
      return this.viewMode === 'overview' ? broadcasts.slice(0, 2) : broadcasts
    }
  }
}
</script>
